import { ManageUsersRolesTable } from "@/components/Templates/ManageUsersRoles";

const ManageUsersRolesPage = () => {
	return <ManageUsersRolesTable />;
};

export default ManageUsersRolesPage;

